import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import type AHDate from "_shared/dates/date";
import { bubbleTimeLabel, spokenDateTimeLabel } from "_shared/dates/compact-time-label";

/** Focusable, so a keyboard reader can bring up the tooltip that spells the moment out. "2:52 PM" never breaks. */
const Time = styled("time")(() => ({
  whiteSpace: "nowrap",
}));

type BubbleTimestampProps = {
  date: AHDate;
  className?: string;
  "data-testid"?: string;
};

/**
 * When a message was sent, as a time of day: "2:52 PM" (#7082). The day is said once, by the
 * `ConversationDayDivider` above the run of messages sent on it, so a bubble does not repeat it. A
 * screen reader hears the whole moment and the tooltip spells it out on hover or focus.
 */
export default function BubbleTimestamp(props: Readonly<BubbleTimestampProps>) {
  const { date, className } = props;
  const spoken = spokenDateTimeLabel(date);

  return (
    <Tooltip title={spoken}>
      <Time
        aria-label={spoken}
        className={className}
        data-testid={props["data-testid"]}
        dateTime={date.toISOString()}
        tabIndex={0}
      >
        <span aria-hidden>{bubbleTimeLabel(date)}</span>
      </Time>
    </Tooltip>
  );
}
